import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useForm } from "react-hook-form"
import { setFormUtmParams, submitHubspotForm } from "../../utils/utils"
import * as S from "./subscribe-form.styles"

export const SubscribeForm = ({
  setSuccessMessage,
  shouldSendCookies = true,
}) => {
  const portalId = "21349178"
  const formId = "1562079e-7f4f-4353-b1d8-799fa1c41109"
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
  })

  const onSubmit = async data => {
    setErrorMessage("")
    setIsLoading(true)

    submitHubspotForm(
      {
        ...data,
      },
      portalId,
      formId,
      shouldSendCookies
    )
      .then(res => {
        setIsLoading(false)

        if (res && res.data) {
          if (res.data.status === "error") {
            if (
              res.data.errors[0].message.split("'")[1].split(".")[1] === "email"
            ) {
              if (res.data.errors[0].errorType === "INVALID_EMAIL") {
                setErrorMessage("Invalid email , please check and try again.")
              } else if (res.data.errors[0].errorType === "BLOCKED_EMAIL") {
                setErrorMessage("Blocked email , please use another email.")
              }
            }
          } else if (res && res.data) {
            //navigate("/thank-you?form=contact-sales")
            setSuccessMessage("Thank you for your subscription")
          } else {
            setErrorMessage(
              "There was an error with your submission. Please try again."
            )
          }
        }
      })
      .catch(e => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    setFormUtmParams(setValue)
  }, [])

  return (
    <form
      data-form-id={formId}
      data-portal-id={portalId}
      onSubmit={handleSubmit(onSubmit)}
      style={{ width: "100%" }}
    >
      <S.Wrapper>
        <S.FormWrapper>
          <S.InputText
            size="small"
            fullWidth
            errors={errors}
            name="email"
            required
            type="email"
            autoComplete="email"
            register={register}
            label=""
            placeholder="Enter your email..."
          />

          <S.Button type="submit" disabled={isLoading} disableRipple>
            {isLoading && (
              <S.FormSpinner>
                <S.CustomSpinner />
              </S.FormSpinner>
            )}
            Sign up
          </S.Button>
        </S.FormWrapper>
        {errorMessage && <S.ErrorMessage>{errorMessage} </S.ErrorMessage>}
      </S.Wrapper>
    </form>
  )
}

export default SubscribeForm

SubscribeForm.propTypes = {
  setSuccessMessage: PropTypes.func.isRequired,
}
